module.exports = __webpack_public_path__ + "static/media/chokha1.fc255e2d.webp";